export const FREE_ANALYTICS_SKU = 'analytics_basic_2000';

export const FREE_FEEDBACK_SKU = 'feedback_basic_20';
